module.exports = __webpack_public_path__ + "media/images/flags/64/Isle-of-Man-319888d56482fbd65a5a13ffafba4ae7.png";